import { useBrowserNavigation } from '@marketplace-web/browser/browser-navigation-util'
import { useLatestCallback } from '@marketplace-web/shared/ui-state-util'
import { toParams, toUrlQuery } from '@marketplace-web/browser/url-util'

const useItemsCatalogQuery = () => {
  const { page, time } = useBrowserNavigation().searchParams

  const setQuery = useLatestCallback(
    (
      key: string,
      value: string | number,
      method: 'replaceState' | 'pushState' = 'replaceState',
    ) => {
      const stringValue = String(value)

      const url = new URL(window.location.href)
      const params = toParams(url.search)
      params[key] = stringValue

      const updated = `${url.pathname}?${toUrlQuery(params)}`

      window.history[method](null, '', updated)
    },
  )

  return {
    setQuery,
    page: page ? Number(page) : 1,
    time: time ? Number(time) : undefined,
  }
}

export default useItemsCatalogQuery
